import React from 'react';
import { ValueLabel } from '@features/ax/shared/ValueLabel';
import { Badge } from '@shared/ui/badge';
import { RefreshCw, ShieldCheck, Clock, BarChart3, Server } from 'lucide-react';
import { GenericTable } from '@shared/components/GenericTable';
import { TableColumn } from '@shared/types/table';

export const SyncOverviewTab: React.FC = () => {
  const columns: TableColumn[] = [
    { key: "syncDate", header: "Sync Date", type: "text" },
    { key: "syncTime", header: "Sync Time", type: "text" },
    { key: "triggeredBy", header: "Triggered By", type: "text" },
    { key: "devicesPolled", header: "Devices Polled", type: "text" },
    { key: "readsSynced", header: "Reads Synced", type: "text" },
    { key: "pendingReads", header: "Pending Reads", type: "text" },
    { key: "exceptions", header: "Exceptions", type: "text" },
    { key: "duration", header: "Duration", type: "text" },
    { key: "status", header: "Status", type: "text" },
    { key: "notes", header: "Notes", type: "text" },
  ];

  return (
    <div className="space-y-6 pt-2">
      {/* Top Sync KPIs */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Total Syncs */}
        <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-xs font-medium text-gray-500">Total Syncs</p>
            <p className="text-2xl font-bold text-gray-900">NA</p>
          </div>
          <div className="w-8 h-8 rounded-lg bg-gray-50 text-gray-400 flex items-center justify-center">
            <RefreshCw className="w-4 h-4" />
          </div>
        </div>

        {/* Total Synced */}
        <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-xs font-medium text-gray-500">Total Synced</p>
            <p className="text-2xl font-bold text-emerald-600">NA</p>
          </div>
          <div className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center">
            <ShieldCheck className="w-4 h-4" />
          </div>
        </div>

        {/* Pending Reads */}
        <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-xs font-medium text-gray-500">Pending Reads</p>
            <p className="text-2xl font-bold text-amber-500">NA</p>
          </div>
          <div className="w-8 h-8 rounded-lg bg-amber-50 text-amber-500 flex items-center justify-center">
            <Clock className="w-4 h-4" />
          </div>
        </div>

        {/* Success Rate */}
        <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-xs font-medium text-gray-500">Success Rate</p>
            <p className="text-2xl font-bold text-purple-600">NA</p>
          </div>
          <div className="w-8 h-8 rounded-lg bg-purple-50 text-purple-600 flex items-center justify-center">
            <BarChart3 className="w-4 h-4" />
          </div>
        </div>
      </div>

      {/* Head-End Vendor Section */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm space-y-5">
        <div className="flex items-center justify-between pb-3 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center">
              <Server className="w-5 h-5" />
            </div>
            <div>
              <h4 className="text-sm font-semibold text-gray-900">
                NA
              </h4>
              <p className="text-xs text-gray-500">
               NA
              </p>
            </div>
          </div>
          <Badge
            variant="outline"
            className="bg-emerald-50 text-emerald-700 border-emerald-200 text-xs font-medium px-2.5 py-0.5 rounded-full"
          >
            Active
          </Badge>
        </div>

        {/* Vendor Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-5 gap-x-8 pt-2">
          <ValueLabel label="Contract No" value="NA" />
          <ValueLabel label="Contract Period" value="NA" />
          <ValueLabel label="License Expiry" value="NA" />
          <ValueLabel label="Coverage Services" value="NA" />
          <ValueLabel label="Head-End System" value="NA" />
          <ValueLabel label="Protocol" value="NA" />
        </div>
      </div>

      {/* Sync History Section */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm space-y-4">
        <h3 className="text-base font-semibold text-gray-900">Sync History</h3>
        <GenericTable
          data={[]}
          columns={columns}
          rowKey="id"
          loading={false}
          emptyMessage="No sync history found"
        />
      </div>
    </div>
  );
};
export default SyncOverviewTab;
